// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  useColorModeValue,
  Center,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { CheckIcon, InfoIcon, QuestionIcon } from '@chakra-ui/icons';
// Custom components
import Card from "components/card/Card.js";
import React, { useState } from "react";
import axios from "axios";
import { decryptData, URL_WEB_BACKEND } from "CustomUtil";

export default function AddInfo({ onRefresh }) {
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));
  const [judul, setJudul] = useState('');
  const [isiInfo, setIsiInfo] = useState('');
  const [statusConfPost, setStatusConfPost] = useState(false);
  const [titleDialog, setTitleDialog] = useState('title');
  const [descDialog, setDescDialog] = useState('desc');
  const [statusInfoDialog, setStatusInfoDialog] = useState(false);
  const [infoDialogIcon, setInfoDialogIcon] = useState(1);
  const cekadmin = decryptData(localStorage.getItem("authrolesemakinpas"));
  const toast = useToast();

  const confPost = () => {
    if (judul === '' || isiInfo === '') {
      toast({
        status: 'error',
        title: 'Proses Gagal',
        description: 'Masih ada kolom yang kosong',
        position: 'bottom-right',
        isClosable: true,
      });
    } else {
      setStatusConfPost(true);
    }
  }

  const exePost = async () => {
    setStatusConfPost(false);
    if (cekadmin === 'admin' || cekadmin === 'tu' || cekadmin === 'keu' || cekadmin === 'um') {
      await axios.post(URL_WEB_BACKEND + '/infos', {
        judul: judul,
        isi: isiInfo,
        tanggal: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toJSON().slice(0, 19).replace('T', ' ')
      },
        {
          headers: {
            'Authorization': 'Bearer ' + authdata
          }
        }).then(res => {
          if (res.status === 201) {
            onRefresh(); setJudul(''); setIsiInfo('');
            showInfoDialog('Berhasil', 'Informasi berhasil dikirim.', 0);
          } else {
            let reskey = Object.keys(res.response.data.messages)[0];
            showInfoDialog('Error Mengirim Informasi dengan status ' + res.response.status, res.response.messages[reskey], 1)
          }
        }).catch(err => {
          let errkey = Object.keys(err.response.data.messages)[0];
          showInfoDialog('Error Mengirim Informasi dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
        })
    } else {
      showInfoDialog('Error Hapus', 'Anda tidak memiliki hak akses untuk ini.', 1)
    }
  }

  function showInfoDialog(title, desc, infoicon) {
    setTitleDialog(title); setDescDialog(desc); setInfoDialogIcon(infoicon); setStatusInfoDialog(true);
  }

  const viewInfoDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusInfoDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>{titleDialog}</ModalHeader>
          <ModalBody>
            <Center>
              {infoDialogIcon
                ? <InfoIcon w={16} h={16} color="blue.500" />
                : <CheckIcon w={16} h={16} color="green.500" />
              }
            </Center>
            <Center mt={8}>
              <Text fontSize='large'>{descDialog}</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => { setStatusInfoDialog(false) }}>OK</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  return (
    <Card mb='0px' align='center' p='20px'>
      <Flex h='100%' direction={{ base: "column", "2xl": "column" }}>
        <Flex direction='column'>
          {viewInfoDialog()}
          <Modal closeOnOverlayClick={false} isCentered isOpen={statusConfPost}>
            <ModalOverlay
              bg='blackAlpha.300'
              backdropFilter='blur(10px) hue-rotate(10deg)'
            />
            <ModalContent>
              <ModalHeader>Kirim Informasi</ModalHeader>
              <ModalBody>
                <Center><QuestionIcon w={16} h={16} color="blue.500" /></Center>
                <Text fontSize='large'>Kirim informasi ke semua pengguna?</Text>
              </ModalBody>
              <ModalFooter>
                <Button colorScheme='red' mr={3} onClick={() => { exePost() }}>
                  Iya, Kirim
                </Button>
                <Button onClick={() => { setStatusConfPost(false) }}>Batal</Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
          <Text
            color={textColorPrimary}
            fontWeight='bold'
            textAlign='start'
            fontSize='2xl'
            mt={{ base: "5px", "2xl": "5px" }}>
            Kirim Informasi
          </Text>
          <Text
            color={textColorSecondary}
            fontSize='md'
            my={{ base: "auto", "2xl": "10px" }}
            textAlign='start'>
            kepada semua pengguna aplikasi SemakinPas.
          </Text>
          <Flex w='100%' mt={{ base: "20px", "2xl": "20px" }} >
            <FormControl id="profil" isRequired>
              <FormLabel>Judul</FormLabel>
              <Input id='profil1' placeholder="Masukkan judul informasi" borderRadius="16px" value={judul} onChange={(e) => setJudul(e.target.value)} />
              <FormLabel>Isi Informasi</FormLabel>
              <Textarea id='profil2' placeholder="Masukkan isi informasi" borderRadius="16px" value={isiInfo} onChange={(e) => setIsiInfo(e.target.value)} />
              <Button
                me='100%'
                mb='50px'
                w='140px'
                minW='140px'
                mt={{ base: "20px", "2xl": "10px" }}
                variant='brand'
                fontWeight='500'
                onClick={confPost}>
                Kirim
              </Button>
            </FormControl>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
